// @flow
export { default } from './PostPlaceholder';



// WEBPACK FOOTER //
// ./src/components/post/PostPlaceholder/index.js